import { ChildProps } from '@/common/util/props'

import Background from '@/components/view/layouts/page/Background'
import CenterMain from '@/components/view/layouts/page/CenterMain'

import LoginPageMessages from '@/components/container/page/login/LoginPageMessages'

const LoginPageLayout = ({ children }: ChildProps) => {
  return (
    <>
      <Background />
      <CenterMain>
        <LoginPageMessages />
        <img src={'/assets/login-logo.png'} alt='logo' className='mx-auto w-120' />
        <div className='shadow-login bg-surface border-secondary overflow-hidden rounded-xl border'>
          <div className='shadow-login-in flex w-120 flex-col px-20 pt-12 pb-18'>{children}</div>
        </div>
      </CenterMain>
    </>
  )
}

export default LoginPageLayout
